export const dashboardData = {
  summary: {
    totalSalesLiters: 15420.5,
    totalSalesAmount: 1450200.0,
    totalCollections: 1445000.0,
    difference: -5200.0
  },
  salesByType: [
    { name: 'Petrol', value: 850000, color: '#f97316' },
    { name: 'Diesel', value: 600200, color: '#3b82f6' }
  ],
  collectionsByMode: [
    { name: 'Cash', value: 800000, color: '#10b981' },
    { name: 'UPI', value: 500000, color: '#6366f1' },
    { name: 'Card', value: 145000, color: '#8b5cf6' }
  ],
  salesTrend: [
    { time: '06:00', sales: 45000 },
    { time: '09:00', sales: 120000 },
    { time: '12:00', sales: 250000 },
    { time: '15:00', sales: 180000 },
    { time: '18:00', sales: 300000 },
    { time: '21:00', sales: 410000 },
    { time: '23:59', sales: 145200 }
  ]
};

export const employees = [
  { id: 'E001', name: 'John Doe', mobile: '9876543210', status: 'Active' },
  { id: 'E002', name: 'Jane Smith', mobile: '8765432109', status: 'Active' },
  { id: 'E003', name: 'Robert Fox', mobile: '7654321098', status: 'Inactive' }
];

export const fuelRates = {
  date: '2026-06-03',
  Petrol: 95.25,
  Diesel: 89.40,
  Xtragreen: 92.15
};

export const pumpConfigurations = [
  { pumpId: 1, nozzles: [{ id: 1, type: 'Petrol' }, { id: 2, type: 'Diesel' }] },
  { pumpId: 2, nozzles: [{ id: 1, type: 'Petrol' }, { id: 2, type: 'Diesel' }] },
  { pumpId: 3, nozzles: [{ id: 1, type: 'Xtragreen' }, { id: 2, type: 'Diesel' }] },
  { pumpId: 4, nozzles: [{ id: 1, type: 'Petrol' }, { id: 2, type: 'Petrol' }] },
  { pumpId: 5, nozzles: [{ id: 1, type: 'Diesel' }, { id: 2, type: 'Diesel' }] },
  { pumpId: 6, nozzles: [{ id: 1, type: 'Petrol' }, { id: 2, type: 'Xtragreen' }] },
];

export const tanks = [
  { id: 1, name: 'Tank 1', type: 'Petrol', capacity: 20000, currentStock: 14500 },
  { id: 2, name: 'Tank 2', type: 'Diesel', capacity: 20000, currentStock: 18200 },
  { id: 3, name: 'Tank 3', type: 'Diesel', capacity: 20000, currentStock: 8500 },
  { id: 4, name: 'Tank 4', type: 'Xtragreen', capacity: 10000, currentStock: 7100 },
];

export const mockMorningReadings = {
  date: '2026-06-03',
  readings: {
    1: { 1: 150000, 2: 120000 },
    2: { 1: 180000, 2: 110000 },
    3: { 1: 50000,  2: 95000 },
    4: { 1: 160000, 2: 165000 },
    5: { 1: 200000, 2: 210000 },
    6: { 1: 175000, 2: 60000 }
  }
};
